/* eslint-disable import/order */
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsGlobalPermissionsRoute } from '@jira/router-routes__admin-pages-global-permissions-routes/src/globalSettingsGlobalPermissionsRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalPermissionsEntryPoint } from '@jira/permissions-administration__pages-global-permissions/src/globalPermissionsEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsGlobalPermissionsRouteEntry: Route = createEntry(
	globalSettingsGlobalPermissionsRoute,

	() => ({
		entryPoint() {
			return fg('olympus-global-permissions-fe-modernisation')
				? createPageEntryPoint({
						main: globalPermissionsEntryPoint,
					})
				: undefined;
		},

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
